import playerData from "../localData/playerData.json";

const players = (state = playerData, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
export default players;
